var PD = PD || {};
PD.forms = (function(f) {
  /**
   * Constructor for a new form window, with custom title, fields and actions.
   * @param  {String} title            Title of the window
   * @param  {String|Element} content  HTML or jQuery element to use as content for modal.
   * @param  {Object} cfg              See below for description
   * 
   * cfg: {
   *   show: {Boolean} true, // whether to immediately show the modal
   *   ignoreBackdrop: {Boolean} false, // if true, clicking the backdrop won't hide modal
   *   keyboard: {Boolean} false, // if false, the escape button won't hide the modal
   *   actionText: {String} _("Submit"), // the text to show on submit button
   * }
   *
   * The following events are emitted by the instance (actually proxies jQuery's event emitter):
   *   window:hidden - When the window has been hidden
   *   window:shown - When the window has been shown
   *   window:destroy - When the window is being removed
   *   form:submitted - When a valid input has been submitted
   */
  function FormWindow(title, fields, cfg){
    cfg = cfg || {};

    // generate the form to use as input
    this.form = new PD.forms.Form(fields, cfg.formAction || this._onSubmitted.bind(this), cfg.actionText);
    var self = this;
    this.form.$actions.click(function(){
      self.form.$elm.submit();
    });

    cfg.actions = [];
    if (cfg.cancelButton) {
      cfg.actions.push({
        click: function() {
          this.window.hide();
        }.bind(this),
        text: _("Cancel"),
        classes: ["btn-default"]
      });
    }
    var $actionsContainer = this.form.$actions.closest(".form-group");
    cfg.actions.push(this.form.$actions);
    $actionsContainer.remove();
    this.form.$actions.on("click", this.form._submit.bind(this.form));

    var content = [];
    if (cfg.text) {
      content.push("<p>"+cfg.text+"</p>");
    }
    content.push(this.form.$elm);

    this.window = new PD.windows.Window(
      title,
      content,
      cfg
    );

    this.form.window = this.window;

    // proxy jQuery's event emitter
    this.on = this.window.on.bind(this.window);
    this.trigger = this.window.trigger.bind(this.window);

    // proxy selected methods from window/form
    this.show = this.window.show.bind(this.window);
    this.hide = this.window.hide.bind(this.window);
    this.destroy = this.window.destroy.bind(this.window);
  }
  FormWindow.prototype._onSubmitted = function(vals){
    // emit submit event
    this.trigger("form:submitted", vals);

    return false; // stop redirect to same page
  };

  f.FormWindow = FormWindow;
  return f;
})(PD.forms || {});
// TODO: Actions
